import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

interface IProps {
  // title: string;
  body: string;
  title: string;
  show: boolean;
  onClose: () => void;
}

const AlertWithModal: React.FC<IProps> = (props) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(props.show);
    console.log("show status2:", props.show);

    console.log("Alert body:", props.body);
  }, [props.show, props.body]);

  const handleClose = () => {
    setShow(false);
    props.onClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        style={{
          marginTop: "40px",
          paddingTop: "20px",
          transform: "translate(0%, 0%)",
        }}
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Title>{props.title}</Modal.Title>
        {/* </Modal.Header> */}
        <Modal.Body>{props.body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AlertWithModal;
